"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Menudotted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Menudotted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "menudotted"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,39.5A10.5,10.5,0,1,0,60.5,50,10.512,10.512,0,0,0,50,39.5Zm0,16A5.5,5.5,0,1,1,55.5,50,5.506,5.506,0,0,1,50,55.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,28.5A10.5,10.5,0,1,0,39.5,18,10.512,10.512,0,0,0,50,28.5Zm0-16A5.5,5.5,0,1,1,44.5,18,5.506,5.506,0,0,1,50,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,71.5A10.5,10.5,0,1,0,60.5,82,10.512,10.512,0,0,0,50,71.5Zm0,16A5.5,5.5,0,1,1,55.5,82,5.506,5.506,0,0,1,50,87.5Z"
  })))));
}